import { useTypedQuery } from "hooks";
import { TyresDashboardQueryKeys } from "modules/TyresDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DropdownItemProps } from "components";

const formatBrands = (brands: string[]): DropdownItemProps<string>[] => brands.map(brand => ({ key: brand, value: brand, text: brand }));

export const useBrandsQuery = () =>
  useTypedQuery({
    queryKey: TyresDashboardQueryKeys.brands,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.get(endpoint, baseUrl)).data.brands,
    select: formatBrands
  });
